<div id="DefinitionExpressionComponent" [class.disabled]="false" #DefinitionExpressionComponent>
  <form>
    <div class="form-row">

      <div class="form-group col-10">

        <label for="filter-select">{{selectboxLabel | translate}}</label>

        <select id="filter-select" class="form-control form-control-sm" name="create-polygon"
                [(ngModel)]="selectedFilterValue"
                [disabled]="isDisabled"
        >
          <option></option>
          <option *ngFor="let attributeValue of filterAttribute" [ngValue]="attributeValue.code"
                  [selected]="" translate>
            {{ attributeValue.name }}
          </option>

        </select>

      </div>
    </div>
  </form>
</div>
